export enum LicensesIssuerEnum {
  ADPE = "ADPE",  // Department of Planning & Economy, Abu Dhabi
  OutsideUAE = "OutsideUAE",
  GOVEntity = "GOVEntity"
}
